import { z } from 'zod';

export const basicDetailsSchema = z.object({
  name: z.string().min(2, 'Please enter name of store'),
  type: z.string().min(2, 'select a type of store'),
  location: z.string().min(2, 'select correct location'),
  logo: z.string().min(2, 'upload a store logo')
});
export type basicDetailsType = z.infer<typeof basicDetailsSchema>;

export const parametersSchema = z.object({
  all: z.boolean(),
  inventory: z.boolean(),
  manageRequests: z.boolean(),
  procurement: z.boolean(),
  wasteReport: z.boolean(),
  vendors: z.boolean(),
  trash: z.boolean()
});
export type parametersType = z.infer<typeof parametersSchema>;

export const parametersField = [
  {
    name: 'All parameters',
    id: 'all'
  },
  {
    name: 'Inventory',
    id: 'inventory'
  },
  {
    name: 'Manage requests',
    id: 'manageRequests'
  },
  {
    name: 'Procurement',
    id: 'procurement'
  },
  {
    name: 'Waste report',
    id: 'wasteReport'
  },
  {
    name: 'Vendors',
    id: 'vendors'
  },
  {
    name: 'Trash',
    id: 'trash'
  }
];

export const rolesPermissionSchema = z.object({
  userRoles: z.array(
    z.object({
      role: z.string(),
      name: z.string(),
      email: z.string(),
      status: z.string()
    })
  )
});
export type rolesPermissionSchemaType = z.infer<typeof rolesPermissionSchema>;
